import logo from '../../assets/images/ticket-logo.svg';

import React, { useMemo } from 'react';
import moment from 'moment';

import config from '../../config.json';
import { numberFormat } from './../../utils/numberFormat';

export default function Ticket(props) {
	const { bonifica, subTotal, details, service } = useMemo(() => {
		const bonifica = props.detail?.filter(d => d.debitCreditIndicator === 'C')
			.reduce((acc, cur) => acc + cur.value, 0);

		const subTotal = props.detail?.filter(d => d.debitCreditIndicator === 'D')
			.reduce((acc, cur) => acc + cur.value, 0);

		// Sort details
		const details = props.detail?.sort((a, b) => {
			const nameA = a.debitCreditIndicator.toUpperCase();
			const nameB = b.debitCreditIndicator.toUpperCase();
			return nameB < nameA ? -1 : nameB > nameA ? 1 : 0;
		});

		const service = props.detail?.reduce((set, e) =>
			e.contractId ? set.add(parseInt(e.contractId)) : set,
			new Set());
		
		return {
			bonifica,
			subTotal,
			details,
			service
		}
	}, [props.detail]);

	return (
		<div>
			<div className="centrado">
				<img style={{ width: '100%' }} alt='logo' src={logo} />
			</div>
			<div className='t-info'>
				<p>{props.organizationName}</p>
				{props.salesOfficePostalCode && <p>Lugar Expedición: {props.salesOfficePostalCode}</p>}
				<p>RFC: {props.organizationRFC}</p>
				<div id="contenedor">
					<div>
						<p>Recibo: # {(props.ticketNumber) * 1}</p>
					</div>
					<div>
						<p>Oficina: # {props.salesOfficeId}</p>
					</div>
				</div>
				<p>Fecha: {moment().format(config.dateTimeFormat)}</p>
				<div id="contenedor">
					<div>
						<p>Cliente: {props.clientId}</p>
					</div>
					<div>
						<p>Servicio: # {service}</p>
					</div>
				</div>
				<p>{props.clientName}</p>
				<p>RFC: {props.clientRFC}</p>
				<p>&nbsp;</p>
			</div>
			<table>
				<thead>
				</thead>
				<tbody>
					{details && details
						.filter(d => d.debitCreditIndicator === 'D')
						.map((element) => (
							<tr key={element.accountingDetailId}>
								<td className='producto'>
									{element.productDescription}&nbsp;{element.text}
								</td>
								<td className='precio txt-end'>
									{numberFormat(element.value)}
								</td>
							</tr>
						))}
					<tr>
						<td className='producto'>Bonificaciones:</td>
						<td className='precio txt-end'>
							{numberFormat(bonifica * -1)}
						</td>
					</tr>
					<tr>
						<td><hr /></td>
						<td><hr /></td>
					</tr>
					<tr>
						<td className='producto'>Subtotal:</td>
						<td className='precio txt-end'>
							{numberFormat(subTotal)}
						</td>
					</tr>
					<tr>
						<td className='producto'>Total:</td>
						<td className='precio txt-end'>
							{numberFormat(subTotal - bonifica)}
						</td>
					</tr>
					{(typeof props.efectivo !== "undefined" && props.efectivo !== null) && <tr>
						<td className='producto'>Efectivo:</td>
						<td className='precio txt-end'>
							{numberFormat(props.efectivo)}
						</td>
					</tr>}
					{(typeof props.cambio !== "undefined" && props.cambio !== null) && <tr>
						<td className='producto'>Cambio:</td>
						<td className='precio txt-end'>
							{numberFormat(props.cambio)}
						</td>
					</tr>}
				</tbody>
			</table>
			<div className='foo-ticket'>
				<p>.</p>
			</div>
		</div>
	);
}
